import { ALL_PRODUCT_TYPES } from "constants/chart.constants";
import type { IMapRequest } from "stores/map";

import { EntityKind } from "models/entityKind";

import { MapRequestParams } from "./factory";
import { nullBinValues, sanitizeColorLockedItems } from "./utils";

export function generateFacilitiesRequest(states: MapRequestParams): Maybe<IMapRequest> {
  const {
    email,
    GroupBy,
    ColorPalette,
    FilterId,
    ReverseColor,
    ShowGroupsNotInFilter,
    PlaceholderBinsEnabled,
    HasCheckedBins,
    NormalizeBySetting,
    ColorLockedItems = {},
    SortBy,
    DefaultSignificantFigures,
    UseStrictRounding
  } = states;

  if (!email) {
    return undefined;
  }

  const requestGroupBy = nullBinValues(GroupBy);

  return {
    UserName: email,
    GroupBy: requestGroupBy,
    ColorPalette,
    Product: ALL_PRODUCT_TYPES.Oil.key,
    LockStyle: false,
    GetBBox: false,
    EntityKind: EntityKind.Facility,
    FilterId,
    ReverseColor,
    ShowGroupsNotInFilter,
    PlaceholderBinsEnabled,
    OverrideSizeLimit: false,
    HasCheckedBins,
    NormalizeBySetting,
    ColorLockedItems: sanitizeColorLockedItems(ColorLockedItems),
    SortBy,
    DefaultSignificantFigures,
    UseStrictRounding
  };
}
